import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    HostBinding,
} from "@angular/core";

@Component({
    selector: "f-file-preview-checkbox",
    templateUrl: "./preview-checkbox.component.html",
    styleUrls: [],
})
export class PreviewCheckboxComponent implements OnInit {
    @HostBinding("class.align-middle") cls1 = true;
    @HostBinding("class.d-inline-flex") cls2 = true;
    @HostBinding("class.preview-checkbox") cls3 = true;

    @Input() checked: boolean = false;
    @Input() id: string;
    @Input() disabled: boolean = false;
    @Input() indeterminate=false;

    @Input() showDragBar = false;

    @Output() checkedChange = new EventEmitter();

    constructor() { }

    ngOnInit() { }

    clickHandler(event) {
        event.stopPropagation();
        if (!this.disabled) {
            this.checked = !this.checked;
            this.checkedChange.emit({ checked: this.checked, id: this.id });
        }
    }
}
